// import clsx from "clsx";
// import { ChevronDown } from "lucide-react";
// import { useEffect, useMemo, useRef, useState } from "react";
// import { Controller, useWatch, type FieldPath, type FieldValues } from "react-hook-form";
// import { useDispatch } from "react-redux";

// import { App_Url_New } from "@/shared/common/static";
// import { PHONE_LENGTHS } from "@/shared/config/contact";
// import { LOCALISATION_CONFIG } from "@/shared/config/localisation";
// import { axiosInstance } from "@/shared/lib/axiosInstance";
// import { getThemeClass, getThemeComponentGroup } from "@/shared/lib/themeComponentClasses";
// import {
//   setMobileCountryCode,
//   type MobileCountryCode,
// } from "@/shared/redux/reducers/mobileCountryCodeSlice";
// import type { AppDispatch } from "@/shared/redux/store/store";
// import { usePosterReducers } from "@/shared/redux/store/useGetData";

// import type { BaseInputProps } from "@/shared/types";
// import { toTitleCaseUi } from "@/shared/utils/titleCase";
// import { inputClassName } from "./TextInput";
// import { WrapperInput } from "./WrapperInput";

// const normalizeCountryCodeResponse = (payload: unknown): MobileCountryCode[] => {
//   const data = (payload as any)?.data;
//   const list = Array.isArray(data) ? data : Array.isArray(payload) ? payload : [];

//   return list
//     .filter((item: any) =>
//       cleanMobileCountryCode(item?.mobile_country_code || item?.mobileCountryCode)
//     )
//     .map((item: any) => ({
//       id: item.id,
//       country_code: String(item.country_code || item.countryCode || ""),
//       mobile_country_code: String(item.mobile_country_code || item.mobileCountryCode || ""),
//       regex_pattern: item.regex_pattern || item.regexPattern,
//     }));
// };

// const cleanMobileCountryCode = (value?: string) => String(value || "").replace(/\D/g, "");

// const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// const getQuantifierLength = (pattern: string, index: number) => {
//   const match = pattern.slice(index).match(/^\{(\d+)(?:,(\d+))?\}/);

//   if (!match) {
//     return { length: 1, nextIndex: index };
//   }

//   return {
//     length: Number(match[2] || match[1]),
//     nextIndex: index + match[0].length,
//   };
// };

// const countPatternDigitLength = (pattern: string): number | null => {
//   let length = 0;

//   for (let index = 0; index < pattern.length; index += 1) {
//     const current = pattern[index];
//     const next = pattern[index + 1];

//     if (current === "\\" && next === "d") {
//       const quantifier = getQuantifierLength(pattern, index + 2);
//       length += quantifier.length;
//       index = quantifier.nextIndex - 1;
//       continue;
//     }

//     if (current === "[") {
//       const closingIndex = pattern.indexOf("]", index);
//       if (closingIndex === -1) return null;

//       const quantifier = getQuantifierLength(pattern, closingIndex + 1);
//       length += quantifier.length;
//       index = quantifier.nextIndex - 1;
//       continue;
//     }

//     if (current === "(") {
//       const closingIndex = pattern.indexOf(")", index);
//       if (closingIndex === -1) return null;

//       const group = pattern.slice(index + 1, closingIndex);
//       const longestOption = Math.max(
//         ...group.split("|").map((option) => countPatternDigitLength(option) || 0)
//       );
//       const quantifier = getQuantifierLength(pattern, closingIndex + 1);
//       length += longestOption * quantifier.length;
//       index = quantifier.nextIndex - 1;
//       continue;
//     }

//     if (/\d/.test(current)) {
//       const quantifier = getQuantifierLength(pattern, index + 1);
//       length += quantifier.length;
//       index = quantifier.nextIndex - 1;
//     }
//   }

//   return length || null;
// };

// const getMobileLocalDigitLength = (country?: MobileCountryCode, fallbackCountryCode?: string) => {
//   const countryCode =
//     cleanMobileCountryCode(country?.mobile_country_code) ||
//     cleanMobileCountryCode(fallbackCountryCode);

//   if (!country?.regex_pattern || !countryCode) {
//     return PHONE_LENGTHS[countryCode] || 15;
//   }

//   const rawPrefix = String(country.mobile_country_code || "").trim();
//   const escapedRawPrefix = escapeRegex(rawPrefix);
//   // Backend regex often starts with \+<code>. Support both escaped and plain + prefixes.
//   const prefixPattern = new RegExp(`^(?:\\\\)?${escapedRawPrefix}`);
//   const localPattern = country.regex_pattern
//     .replace(/^\^/, "")
//     .replace(/\$$/, "")
//     .replace(prefixPattern, "")
//     .replace(/\[[^\]]+\]\?/g, (token) => (/\\s|\s|\\-|-/.test(token) ? "" : token));

//   return countPatternDigitLength(localPattern) || PHONE_LENGTHS[countryCode] || 15;
// };

// const syncPhoneLengthsFromCountryList = (countryList: MobileCountryCode[]) => {
//   countryList.forEach((country) => {
//     const countryCode = cleanMobileCountryCode(country.mobile_country_code);
//     const length = getMobileLocalDigitLength(country, countryCode);

//     if (countryCode && length) {
//       PHONE_LENGTHS[countryCode] = length;
//     }
//   });
// };

// export function MobileNumberInput<
//   TFieldValues extends FieldValues,
//   TName extends FieldPath<TFieldValues>,
// >({
//   control,
//   name,
//   label,
//   description,
//   disabled,
//   required,
//   className,
// }: BaseInputProps<TFieldValues, TName>) {
//   const defaultCountryCode = LOCALISATION_CONFIG.mobileCountryCode;
//   const dispatch = useDispatch<AppDispatch>();
//   const inputClasses = getThemeComponentGroup("input");
//   const { mobileCountryCode: countryList = [] } = usePosterReducers();
//   const countryCodePath = `${name}.countryCode` as FieldPath<TFieldValues>;
//   const numberPath = `${name}.number` as FieldPath<TFieldValues>;
//   const countryCode = useWatch({
//     control,
//     name: countryCodePath,
//   }) as string | undefined;
//   const countryCodeRef = useRef(countryCode || defaultCountryCode);
//   const [open, setOpen] = useState(false);
//   const [search, setSearch] = useState("");

//   const containerRef = useRef<HTMLDivElement>(null);
//   const selectedCountry = useMemo(
//     () =>
//       countryList.find(
//         (country) =>
//           cleanMobileCountryCode(country.mobile_country_code) ===
//           (countryCode || defaultCountryCode)
//       ),
//     [countryCode, countryList, defaultCountryCode]
//   );
//   const maxLength = getMobileLocalDigitLength(selectedCountry, countryCode || defaultCountryCode);
//   const countryCodePlaceholder = toTitleCaseUi("Select country code");
//   const numberPlaceholder = toTitleCaseUi(`Enter ${maxLength} digits`);

//   useEffect(() => {
//     countryCodeRef.current = countryCode || defaultCountryCode;
//   }, [countryCode, defaultCountryCode]);

//   useEffect(() => {
//     if (countryList.length > 0) {
//       return;
//     }

//     let active = true;

//     axiosInstance
//       .get(App_Url_New.ApiEndPoint.mobileCountryCode)
//       .then((response) => {
//         if (!active) {
//           return;
//         }

//         const nextCountryList = normalizeCountryCodeResponse(response.data);
//         syncPhoneLengthsFromCountryList(nextCountryList);
//         dispatch(setMobileCountryCode(nextCountryList));
//       })
//       .catch((error) => {
//         console.error("Failed to fetch mobile country codes:", error);
//       });

//     return () => {
//       active = false;
//     };
//   }, [countryList.length, dispatch]);

//   useEffect(() => {
//     syncPhoneLengthsFromCountryList(countryList);
//   }, [countryList]);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (!containerRef.current?.contains(event.target as Node)) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const validateMobileNumber = (
//     number: string,
//     countryCode: string,
//     countryList: MobileCountryCode[]
//   ) => {
//     const sanitizedNumber = String(number || "").replace(/\D/g, "");
//     const requiredLength = PHONE_LENGTHS[countryCode];

//     const selectedCountry = countryList.find(
//       (country) => cleanMobileCountryCode(country.mobile_country_code) === countryCode
//     );

//     if (!selectedCountry) {
//       return "Invalid country code";
//     }

//     if (!selectedCountry.regex_pattern) {
//       if (requiredLength && sanitizedNumber.length !== requiredLength) {
//         return `Enter a valid ${requiredLength}-digit mobile number`;
//       }

//       return true;
//     }

//     // Add country code before validation
//     // Validate with backend-provided regex and country-code format from API.
//     const fullNumber = `${selectedCountry.mobile_country_code}${sanitizedNumber}`;

//     const regex = new RegExp(selectedCountry.regex_pattern);
//     if (!regex.test(fullNumber)) {
//       return "Please enter a valid mobile number";
//     }

//     return true;
//   };

//   const filteredCountries = useMemo(() => {
//     if (!search.trim()) {
//       return countryList;
//     }

//     const value = search.toLowerCase();

//     return countryList.filter((country) => {
//       return (
//         country.country_code.toLowerCase().includes(value) ||
//         country.mobile_country_code.toLowerCase().includes(value)
//       );
//     });
//   }, [search, countryList]);

//   return (
//     <Controller
//       control={control}
//       name={numberPath}
//       rules={{
//         validate: (value) =>
//           validateMobileNumber(String(value || ""), countryCodeRef.current, countryList),
//       }}
//       render={({ field, fieldState }) => (
//         <WrapperInput
//           label={label}
//           error={fieldState.error?.message}
//           description={description}
//           required={required}
//           className={className}
//         >
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-[3.5fr_6.5fr]">
//             <Controller
//               control={control}
//               name={countryCodePath}
//               render={({ field: countryField }) => (
//                 <div ref={containerRef} className="relative">
//                   <input
//                     type="text"
//                     value={
//                       open
//                         ? search
//                         : selectedCountry
//                           ? `${selectedCountry.country_code} (${selectedCountry.mobile_country_code})`
//                           : ""
//                     }
//                     disabled={disabled}
//                     placeholder={countryCodePlaceholder}
//                     onFocus={() => setOpen(true)}
//                     onChange={(e) => {
//                       setSearch(e.target.value);
//                       setOpen(true);
//                     }}
//                     className={clsx(
//                       inputClassName,
//                       "border pr-10",
//                       getThemeClass(inputClasses.borderColor, "border-theme-border-strong"),
//                       getThemeClass(inputClasses.bgColor, "bg-theme-surface"),
//                       getThemeClass(inputClasses.textColor, "text-theme-text")
//                     )}
//                   />

//                   <ChevronDown
//                     className={clsx(
//                       "absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4",
//                       getThemeClass(inputClasses.placeholderColor, "text-theme-text-soft")
//                     )}
//                   />

//                   {open ? (
//                     <div
//                       className={clsx(
//                         "absolute left-0 right-0 top-[calc(100%+0.35rem)] z-50 max-h-64 overflow-y-auto thin-scrollbar rounded-xl border p-0 shadow-xl",
//                         getThemeClass(inputClasses.borderColor, "border-theme-border-strong"),
//                         getThemeClass(inputClasses.bgColor, "bg-theme-surface")
//                       )}
//                     >
//                       {filteredCountries.map((country) => {
//                         const cleanValue = cleanMobileCountryCode(country.mobile_country_code);

//                         return (
//                           <button
//                             key={`${country.id}-${country.mobile_country_code}`}
//                             type="button"
//                             onMouseDown={(event) => {
//                               event.preventDefault();
//                               countryCodeRef.current = cleanValue;
//                               countryField.onChange(cleanValue);
//                               field.onChange("");
//                               setSearch("");
//                               setOpen(false);
//                             }}
//                             className="w-full px-3 py-2 text-left text-sm hover:bg-theme-surface-soft"
//                           >
//                             {country.country_code} ({country.mobile_country_code})
//                           </button>
//                         );
//                       })}
//                     </div>
//                   ) : null}
//                 </div>
//               )}
//             />

//             <input
//               {...field}
//               value={field.value ?? ""}
//               type="tel"
//               inputMode="numeric"
//               placeholder={numberPlaceholder}
//               maxLength={maxLength}
//               disabled={disabled}
//               onChange={(event) => {
//                 const numericValue = event.target.value.replace(/\D/g, "").slice(0, maxLength);
//                 field.onChange(numericValue);
//               }}
//               className={clsx(
//                 inputClassName,
//                 "border",
//                 getThemeClass(inputClasses.borderColor, "border-theme-border-strong"),
//                 getThemeClass(inputClasses.bgColor, "bg-theme-surface"),
//                 getThemeClass(inputClasses.textColor, "text-theme-text"),
//                 getThemeClass(
//                   inputClasses.placeholderColor,
//                   "placeholder:text-theme-text-placeholder"
//                 ),
//                 getThemeClass(inputClasses.focusBorderColor, "focus:border-theme-primary"),
//                 "focus:ring-2",
//                 getThemeClass(inputClasses.focusRingColor, "focus:ring-theme-primary/10"),
//                 inputClasses.base,
//                 fieldState.error &&
//                   clsx(
//                     inputClasses.errorBorderColor || "border-theme-danger-bright",
//                     "focus:ring-theme-danger-bright/10"
//                   )
//               )}
//             />
//           </div>
//         </WrapperInput>
//       )}
//     />
//   );
// }
import clsx from "clsx";
import { Check, ChevronDown } from "lucide-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useWatch, type FieldPath, type FieldValues } from "react-hook-form";
import { useDispatch } from "react-redux";

import { App_Url_New } from "@/shared/common/static";
import { PHONE_LENGTHS } from "@/shared/config/contact";
import { LOCALISATION_CONFIG } from "@/shared/config/localisation";
import { axiosInstance } from "@/shared/lib/axiosInstance";
import { getThemeClass, getThemeComponentGroup } from "@/shared/lib/themeComponentClasses";
import {
  setMobileCountryCode,
  type MobileCountryCode,
} from "@/shared/redux/reducers/mobileCountryCodeSlice";
import type { AppDispatch } from "@/shared/redux/store/store";
import { usePosterReducers } from "@/shared/redux/store/useGetData";

import type { BaseInputProps } from "@/shared/types";
import { toTitleCaseUi } from "@/shared/utils/titleCase";
import { inputClassName } from "./TextInput";
import { WrapperInput } from "./WrapperInput";

type MobileNumberInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = BaseInputProps<TFieldValues, TName> & {
  defaultCountryCode?: string;
  maxVisibleOptions?: number;
};

const normalizeCountryCodeResponse = (payload: unknown): MobileCountryCode[] => {
  const data = (payload as any)?.data;

  const list = Array.isArray(data) ? data : Array.isArray(payload) ? payload : [];

  return list
    .filter((item: any) =>
      cleanMobileCountryCode(item?.mobile_country_code || item?.mobileCountryCode)
    )
    .map((item: any) => ({
      id: item.id,
      country_code: String(item.country_code || item.countryCode || ""),
      mobile_country_code: String(item.mobile_country_code || item.mobileCountryCode || ""),
      regex_pattern: item.regex_pattern || item.regexPattern,
    }));
};

const cleanMobileCountryCode = (value?: string) => String(value || "").replace(/\D/g, "");

const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const getQuantifierLength = (pattern: string, index: number) => {
  const match = pattern.slice(index).match(/^\{(\d+)(?:,(\d+))?\}/);

  if (!match) {
    return {
      length: 1,
      nextIndex: index,
    };
  }

  return {
    length: Number(match[2] || match[1]),
    nextIndex: index + match[0].length,
  };
};

const countPatternDigitLength = (pattern: string): number | null => {
  let length = 0;

  for (let index = 0; index < pattern.length; index += 1) {
    const current = pattern[index];
    const next = pattern[index + 1];

    if (current === "\\" && next === "d") {
      const quantifier = getQuantifierLength(pattern, index + 2);

      length += quantifier.length;
      index = quantifier.nextIndex - 1;

      continue;
    }

    if (current === "[") {
      const closingIndex = pattern.indexOf("]", index);

      if (closingIndex === -1) {
        return null;
      }

      const quantifier = getQuantifierLength(pattern, closingIndex + 1);

      length += quantifier.length;
      index = quantifier.nextIndex - 1;

      continue;
    }

    if (current === "(") {
      const closingIndex = pattern.indexOf(")", index);

      if (closingIndex === -1) {
        return null;
      }

      const group = pattern.slice(index + 1, closingIndex);

      const longestOption = Math.max(
        ...group.split("|").map((option) => countPatternDigitLength(option) || 0)
      );

      const quantifier = getQuantifierLength(pattern, closingIndex + 1);

      length += longestOption * quantifier.length;

      index = quantifier.nextIndex - 1;

      continue;
    }

    if (/\d/.test(current)) {
      const quantifier = getQuantifierLength(pattern, index + 1);

      length += quantifier.length;
      index = quantifier.nextIndex - 1;
    }
  }

  return length || null;
};

const getMobileLocalDigitLength = (country?: MobileCountryCode, fallbackCountryCode?: string) => {
  const countryCode =
    cleanMobileCountryCode(country?.mobile_country_code) ||
    cleanMobileCountryCode(fallbackCountryCode);

  if (!country?.regex_pattern || !countryCode) {
    return PHONE_LENGTHS[countryCode] || 15;
  }

  const rawPrefix = String(country.mobile_country_code || "").trim();

  const escapedRawPrefix = escapeRegex(rawPrefix);

  const prefixPattern = new RegExp(`^(?:\\\\)?${escapedRawPrefix}`);

  const localPattern = country.regex_pattern
    .replace(/^\^/, "")
    .replace(/\$$/, "")
    .replace(prefixPattern, "")
    .replace(/\[[^\]]+\]\?/g, (token) => (/\\s|\s|\\-|-/.test(token) ? "" : token));

  return countPatternDigitLength(localPattern) || PHONE_LENGTHS[countryCode] || 15;
};

const syncPhoneLengthsFromCountryList = (countryList: MobileCountryCode[]) => {
  countryList.forEach((country) => {
    const countryCode = cleanMobileCountryCode(country.mobile_country_code);

    const length = getMobileLocalDigitLength(country, countryCode);

    if (countryCode && length) {
      PHONE_LENGTHS[countryCode] = length;
    }
  });
};

export function MobileNumberInput<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  label,
  description,
  disabled,
  required,
  className,
  defaultCountryCode = LOCALISATION_CONFIG.mobileCountryCode,
  maxVisibleOptions = 7,
}: MobileNumberInputProps<TFieldValues, TName>) {
  const dispatch = useDispatch<AppDispatch>();

  const inputClasses = getThemeComponentGroup("input");

  const { mobileCountryCode: countryList = [] } = usePosterReducers();

  const countryCodePath = `${name}.countryCode` as FieldPath<TFieldValues>;

  const numberPath = `${name}.number` as FieldPath<TFieldValues>;

  const countryCode = useWatch({
    control,
    name: countryCodePath,
  }) as string | undefined;

  const countryCodeRef = useRef(countryCode || defaultCountryCode);

  const [open, setOpen] = useState(false);

  const [search, setSearch] = useState("");

  // Keyboard highlighted option
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const containerRef = useRef<HTMLDivElement>(null);

  const countryInputRef = useRef<HTMLInputElement>(null);

  const optionRefs = useRef<Array<HTMLDivElement | null>>([]);

  const selectedCountry = useMemo(
    () =>
      countryList.find(
        (country) =>
          cleanMobileCountryCode(country.mobile_country_code) ===
          (countryCode || defaultCountryCode)
      ),
    [countryCode, countryList, defaultCountryCode]
  );

  const maxLength = getMobileLocalDigitLength(selectedCountry, countryCode || defaultCountryCode);

  const countryCodePlaceholder = toTitleCaseUi("Select country code");

  const numberPlaceholder = toTitleCaseUi(`Enter ${maxLength} digits`);

  useEffect(() => {
    countryCodeRef.current = countryCode || defaultCountryCode;
  }, [countryCode, defaultCountryCode]);

  useEffect(() => {
    if (countryList.length > 0) {
      return;
    }

    let active = true;

    axiosInstance
      .get(App_Url_New.ApiEndPoint.mobileCountryCode)
      .then((response) => {
        if (!active) {
          return;
        }

        const nextCountryList = normalizeCountryCodeResponse(response.data);

        syncPhoneLengthsFromCountryList(nextCountryList);

        dispatch(setMobileCountryCode(nextCountryList));
      })
      .catch((error) => {
        console.error("Failed to fetch mobile country codes:", error);
      });

    return () => {
      active = false;
    };
  }, [countryList.length, dispatch]);

  useEffect(() => {
    syncPhoneLengthsFromCountryList(countryList);
  }, [countryList]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) {
        setOpen(false);
        setSearch("");
        setHighlightedIndex(-1);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const validateMobileNumber = (
    number: string,
    selectedCountryCode: string,
    countries: MobileCountryCode[]
  ) => {
    const sanitizedNumber = String(number || "").replace(/\D/g, "");

    const requiredLength = PHONE_LENGTHS[selectedCountryCode];

    const selectedCountry = countries.find(
      (country) => cleanMobileCountryCode(country.mobile_country_code) === selectedCountryCode
    );

    if (!selectedCountry) {
      return "Invalid country code";
    }

    if (!selectedCountry.regex_pattern) {
      if (requiredLength && sanitizedNumber.length !== requiredLength) {
        return `Enter a valid ${requiredLength}-digit mobile number`;
      }

      return true;
    }

    const fullNumber = `${selectedCountry.mobile_country_code}${sanitizedNumber}`;

    const regex = new RegExp(selectedCountry.regex_pattern);

    if (!regex.test(fullNumber)) {
      return "Please enter a valid mobile number";
    }

    return true;
  };

  const filteredCountries = useMemo(() => {
    if (!search.trim()) {
      return countryList;
    }

    const value = search.toLowerCase();

    return countryList.filter(
      (country) =>
        country.country_code.toLowerCase().includes(value) ||
        country.mobile_country_code.toLowerCase().includes(value)
    );
  }, [search, countryList]);

  const activeCountryCode = countryCode || defaultCountryCode;

  const selectedCountryLabel = selectedCountry
    ? `${selectedCountry.country_code} (${selectedCountry.mobile_country_code})`
    : "";

  // Index of the currently saved country inside the filtered list, -1 when not visible.
  const selectedFilteredIndex = useMemo(
    () =>
      filteredCountries.findIndex(
        (country) => cleanMobileCountryCode(country.mobile_country_code) === activeCountryCode
      ),
    [filteredCountries, activeCountryCode]
  );

  // Keep the highlighted option valid whenever the filtered list changes.
  useEffect(() => {
    setHighlightedIndex((current) => {
      if (!filteredCountries.length) {
        return -1;
      }

      if (current < 0) {
        return current;
      }

      return current > filteredCountries.length - 1 ? filteredCountries.length - 1 : current;
    });
  }, [filteredCountries.length]);

  // Scroll the highlighted option into view while navigating with the keyboard.
  useEffect(() => {
    if (!open || highlightedIndex < 0) {
      return;
    }

    optionRefs.current[highlightedIndex]?.scrollIntoView({ block: "nearest" });
  }, [open, highlightedIndex]);

  return (
    <Controller
      control={control}
      name={numberPath}
      rules={{
        validate: (value) =>
          validateMobileNumber(String(value || ""), countryCodeRef.current, countryList),
      }}
      render={({ field, fieldState }) => {
        const closeDropdown = () => {
          setOpen(false);
          setSearch("");
          setHighlightedIndex(-1);
        };

        const openDropdown = () => {
          setOpen(true);
          setHighlightedIndex(
            selectedFilteredIndex >= 0 ? selectedFilteredIndex : filteredCountries.length ? 0 : -1
          );
        };

        const selectCountry = (country: MobileCountryCode, countryField: any) => {
          const cleanValue = cleanMobileCountryCode(country.mobile_country_code);

          countryCodeRef.current = cleanValue;

          if (cleanValue !== activeCountryCode) {
            countryField.onChange(cleanValue);

            // Number length depends on the country, so the old number is no longer valid.
            field.onChange("");
          }

          closeDropdown();
        };

        const handleCountryKeyDown = (
          event: React.KeyboardEvent<HTMLInputElement>,
          countryField: any
        ) => {
          if (disabled) {
            return;
          }

          switch (event.key) {
            case "ArrowDown": {
              event.preventDefault();

              if (!open) {
                openDropdown();

                return;
              }

              setHighlightedIndex((current) => {
                if (!filteredCountries.length) {
                  return -1;
                }

                return current < filteredCountries.length - 1 ? current + 1 : 0;
              });

              return;
            }

            case "ArrowUp": {
              event.preventDefault();

              if (!open) {
                openDropdown();

                return;
              }

              setHighlightedIndex((current) => {
                if (!filteredCountries.length) {
                  return -1;
                }

                if (current <= 0) {
                  return filteredCountries.length - 1;
                }

                return current - 1;
              });

              return;
            }

            case "Enter": {
              // Always prevent the surrounding form from submitting on Enter.
              event.preventDefault();

              if (!open) {
                openDropdown();

                return;
              }

              const selected =
                filteredCountries[highlightedIndex] ??
                (search.trim() ? filteredCountries[0] : undefined);

              if (selected) {
                selectCountry(selected, countryField);

                return;
              }

              closeDropdown();

              return;
            }

            case "Tab": {
              if (!open) {
                return;
              }

              // Tab moves focus away: commit what the user was searching for, then close.
              const selected = search.trim()
                ? (filteredCountries[highlightedIndex] ?? filteredCountries[0])
                : undefined;

              if (selected) {
                selectCountry(selected, countryField);

                return;
              }

              closeDropdown();

              return;
            }

            case "Escape": {
              if (open) {
                event.preventDefault();
                event.stopPropagation();

                closeDropdown();
              }

              return;
            }

            case "Home": {
              if (open && filteredCountries.length) {
                event.preventDefault();

                setHighlightedIndex(0);
              }

              return;
            }

            case "End": {
              if (open && filteredCountries.length) {
                event.preventDefault();

                setHighlightedIndex(filteredCountries.length - 1);
              }

              return;
            }

            default:
              return;
          }
        };

        return (
          <WrapperInput
            label={label}
            error={fieldState.error?.message}
            description={description}
            required={required}
            className={className}
          >
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-[3.5fr_6.5fr]">
              <Controller
                control={control}
                name={countryCodePath}
                render={({ field: countryField }) => (
                  <div
                    ref={containerRef}
                    className="relative"
                    onBlur={(event) => {
                      // Focus left the whole combobox (Tab, click elsewhere): close the list.
                      if (!event.currentTarget.contains(event.relatedTarget as Node | null)) {
                        setOpen(false);
                        setSearch("");
                        setHighlightedIndex(-1);
                      }
                    }}
                  >
                    <input
                      ref={countryInputRef}
                      id={String(countryCodePath)}
                      data-testid={String(countryCodePath)}
                      type="text"
                      value={open ? search : selectedCountryLabel}
                      disabled={disabled}
                      placeholder={
                        open
                          ? selectedCountryLabel || countryCodePlaceholder
                          : countryCodePlaceholder
                      }
                      autoComplete="off"
                      role="combobox"
                      aria-expanded={open}
                      aria-haspopup="listbox"
                      aria-autocomplete="list"
                      aria-controls={`${String(name)}-country-listbox`}
                      aria-activedescendant={
                        open && highlightedIndex >= 0
                          ? `${String(name)}-country-option-${highlightedIndex}`
                          : undefined
                      }
                      /*
                       * Pointer opens/closes the list. Focus alone must not open it,
                       * otherwise returning focus (Shift+Tab, dialogs) reopens the list.
                       */
                      onMouseDown={() => {
                        if (disabled) {
                          return;
                        }

                        if (open) {
                          setOpen(false);
                          setSearch("");
                          setHighlightedIndex(-1);

                          return;
                        }

                        setOpen(true);
                        setHighlightedIndex(
                          selectedFilteredIndex >= 0
                            ? selectedFilteredIndex
                            : countryList.length
                              ? 0
                              : -1
                        );
                      }}
                      onChange={(event) => {
                        setSearch(event.target.value);

                        setOpen(true);

                        setHighlightedIndex(0);
                      }}
                      onKeyDown={(event) => handleCountryKeyDown(event, countryField)}
                      className={clsx(
                        inputClassName,
                        "border pr-10",

                        getThemeClass(inputClasses.borderColor, "border-theme-border-strong"),

                        getThemeClass(inputClasses.bgColor, "bg-theme-surface"),

                        getThemeClass(inputClasses.textColor, "text-theme-text"),

                        getThemeClass(inputClasses.focusBorderColor, "focus:border-theme-primary"),

                        "focus:ring-2",

                        getThemeClass(inputClasses.focusRingColor, "focus:ring-theme-primary/10"),

                        inputClasses.base
                      )}
                    />

                    <ChevronDown
                      aria-hidden="true"
                      className={clsx(
                        "pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2",

                        getThemeClass(inputClasses.placeholderColor, "text-theme-text-soft"),

                        open && "rotate-180"
                      )}
                    />

                    {open ? (
                      <div
                        id={`${String(name)}-country-listbox`}
                        role="listbox"
                        className={clsx(
                          "absolute left-0 right-0 top-[calc(100%+0.35rem)] z-50 max-h-64 overflow-y-auto thin-scrollbar rounded-xl border p-0 shadow-xl",

                          getThemeClass(inputClasses.borderColor, "border-theme-border-strong"),

                          getThemeClass(inputClasses.bgColor, "bg-theme-surface")
                        )}
                        style={{ maxHeight: `${Math.max(1, maxVisibleOptions) * 40}px` }}
                      >
                        {filteredCountries.length > 0 ? (
                          filteredCountries.map((country, index) => {
                            const cleanValue = cleanMobileCountryCode(country.mobile_country_code);

                            const isHighlighted = highlightedIndex === index;

                            const isSelected = cleanValue === activeCountryCode;

                            return (
                              <div
                                id={`${String(name)}-country-option-${index}`}
                                key={`${country.id}-${country.mobile_country_code}`}
                                ref={(node) => {
                                  optionRefs.current[index] = node;
                                }}
                                role="option"
                                aria-selected={isSelected}
                                // Keep focus on the input so the combobox keeps handling keys.
                                onMouseDown={(event) => {
                                  event.preventDefault();

                                  selectCountry(country, countryField);
                                }}
                                onMouseEnter={() => {
                                  setHighlightedIndex(index);
                                }}
                                className={clsx(
                                  "flex w-full cursor-pointer items-center justify-between gap-2 px-3 py-2 text-left text-sm transition-colors",

                                  getThemeClass(inputClasses.textColor, "text-theme-text"),

                                  isHighlighted && "bg-theme-surface-soft",

                                  isSelected && "font-semibold"
                                )}
                              >
                                <span>
                                  {country.country_code} ({country.mobile_country_code})
                                </span>

                                {isSelected ? (
                                  <Check aria-hidden="true" className="h-4 w-4 shrink-0" />
                                ) : null}
                              </div>
                            );
                          })
                        ) : (
                          <div
                            className={clsx(
                              "px-3 py-2 text-sm",

                              getThemeClass(inputClasses.placeholderColor, "text-theme-text-soft")
                            )}
                          >
                            No countries found
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                )}
              />

              <input
                {...field}
                id={field.name}
                data-testid={field.name}
                value={field.value ?? ""}
                type="tel"
                inputMode="numeric"
                placeholder={numberPlaceholder}
                maxLength={maxLength}
                disabled={disabled}
                onChange={(event) => {
                  const numericValue = event.target.value.replace(/\D/g, "").slice(0, maxLength);

                  field.onChange(numericValue);
                }}
                className={clsx(
                  inputClassName,
                  "border",

                  getThemeClass(inputClasses.borderColor, "border-theme-border-strong"),

                  getThemeClass(inputClasses.bgColor, "bg-theme-surface"),

                  getThemeClass(inputClasses.textColor, "text-theme-text"),

                  getThemeClass(
                    inputClasses.placeholderColor,
                    "placeholder:text-theme-text-placeholder"
                  ),

                  getThemeClass(inputClasses.focusBorderColor, "focus:border-theme-primary"),

                  "focus:ring-2",

                  getThemeClass(inputClasses.focusRingColor, "focus:ring-theme-primary/10"),

                  inputClasses.base,

                  fieldState.error &&
                    clsx(
                      inputClasses.errorBorderColor || "border-theme-danger-bright",

                      "focus:ring-theme-danger-bright/10"
                    )
                )}
              />
            </div>
          </WrapperInput>
        );
      }}
    />
  );
}
